import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { appEvents } from '@/lib/events';

/**
 * Listens for `subscription-expired` events emitted by the http client and
 * routes the operator to /suspended with the relevant context. Mounts once
 * inside the router tree.
 */
export function SubscriptionGuard() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    return appEvents.on('subscription-expired', (payload) => {
      // Don't bounce-loop the user if they're already on /suspended.
      if (location.pathname === '/suspended') return;
      navigate('/suspended', { state: payload, replace: false });
    });
  }, [navigate, location.pathname]);

  return null;
}
